import { Heartbeat } from "@phosphor-icons/react";

export const REC_TONE = {
  replace_now: "text-red-700 bg-red-50 border-red-200 dark:text-red-400 dark:bg-red-950/30 dark:border-red-800",
  plan_replacement: "text-amber-700 bg-amber-50 border-amber-200 dark:text-amber-400 dark:bg-amber-950/30 dark:border-amber-800",
  monitor: "text-blue-700 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-950/30 dark:border-blue-800",
  keep: "text-emerald-700 bg-emerald-50 border-emerald-200 dark:text-emerald-400 dark:bg-emerald-950/30 dark:border-emerald-800",
};
export const REC_HEX = { replace_now: "#b91c1c", plan_replacement: "#b45309", monitor: "#1d4ed8", keep: "#047857" };
export const REC_LABEL = { replace_now: "Replace now", plan_replacement: "Plan replacement", monitor: "Monitor", keep: "Keep" };
export const scoreTone = (s) => (s < 35 ? "replace_now" : s < 55 ? "plan_replacement" : s < 75 ? "monitor" : "keep");

export function AssetHealthBadge({ health, compact = false, testid, className = "" }) {
  if (!health || health.score === undefined || health.score === null) return null;
  const rec = health.recommendation || scoreTone(health.score);
  return (
    <span className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${REC_TONE[rec]} ${className}`} data-testid={testid} title={`Health ${health.score}/100 · ${health.recommendation_label || REC_LABEL[rec]}`}>
      <Heartbeat size={11} weight="bold" /> {health.score}{!compact && <span className="font-normal">· {health.recommendation_label || REC_LABEL[rec]}</span>}
    </span>
  );
}
